import Auth from 'modules/Auth';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { ACCESS_CONFIG } from './InsightsAccessConfig';
import { HasAccessType, UseHasInsightsAccess } from './useHasInsightsAccess.types';
import { FeatureFlagsAndPermissions } from './InsightsAccessConfig.types';

const useHasInsightsAccess = (): UseHasInsightsAccess => {
  const environmentId = useSelector((state: RootState) => state.environment.environmentId);
  const publisherFeatures = useSelector((state: RootState) => state.publisher.publisherFeatures);

  const hasFeatureAccess = (featureName: string): boolean => {
    return publisherFeatures[featureName]?.includes(environmentId) || false;
  };

  const checkFeatureFlagsAndPermissions = (el: FeatureFlagsAndPermissions): boolean => {
    if (!el.featureFlags || el.featureFlags.length === 0) return false;

    return el.featureFlags.every(hasFeatureAccess) && (!el.permissions || el.permissions.every(Auth.hasPermission));
  };

  const hasAccess = Object.entries(ACCESS_CONFIG).reduce((acc, [key, value]) => {
    const hasTabsAccess = checkFeatureFlagsAndPermissions(value.tabs);
    const hasLabsAccess = checkFeatureFlagsAndPermissions(value.labs);

    return {
      ...acc,
      tabs: {
        ...acc.tabs,
        [key]: hasTabsAccess,
      },
      labs: {
        ...acc.labs,
        [key]: !hasTabsAccess && hasLabsAccess,
      },
    };
  }, {} as HasAccessType);

  const showLabsDropdown = Object.values(hasAccess.labs).some(Boolean);

  return {
    hasAccess,
    showLabsDropdown,
  };
};

export default useHasInsightsAccess;
